// Umiestnenie v rebríčku — medailový štvorček (1. zlatá · 2. strieborná · 3. bronzová,
// ďalej neutrálna). Doteraz bol ten istý inline blok skopírovaný v archíve aj v náhľade
// výzvy; tu je raz, aby sa farby ani veľkosti nerozchádzali.
// size: md (26, default) | sm (22). `place` = poradie (1, 2, 3…); prázdne → „–".
export function RankChip({ place, size = "md" }) {
  const cls = `bz-rankchip bz-rankchip--${place >= 1 && place <= 3 ? ["gold", "silver", "bronze"][place - 1] : "plain"}`
    + (size === "sm" ? " bz-rankchip--sm" : "");
  return <span className={cls}>{place || "–"}</span>;
}
